import { useState, useCallback } from 'react';
import { debounce } from '../services/debounce';
const useSearch = (onSearchChange) => {
    const [searchQuery, setSearchQuery] = useState('');
    const handleSearchChanged = (value) => {
        onSearchChange?.();
        setSearchQuery(value);
    };
    const debouncedSetSearchQuery = useCallback(debounce(handleSearchChanged, 500), [handleSearchChanged]);
    return {
        debouncedSetSearchQuery,
        searchQuery,
    };
};
export default useSearch;
